var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 26.0307H18",
    stroke: "#8A8D9C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3327 3.36401H23.3327V26.0307C23.3327 26.7379 23.0517 27.4162 22.5516 27.9163C22.0515 28.4164 21.3733 28.6973 20.666 28.6973H11.3327C10.6254 28.6973 9.94716 28.4164 9.44706 27.9163C8.94697 27.4162 8.66602 26.7379 8.66602 26.0307V6.03068C8.66602 5.32344 8.94697 4.64516 9.44706 4.14506C9.94716 3.64497 10.6254 3.36401 11.3327 3.36401V3.36401Z",
    stroke: "#8A8D9C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7eb12bb84a3cb95d0c897957bead5744.svg";
export { ForwardRef as ReactComponent };